import { action, makeObservable, observable, runInAction } from 'mobx';
import { Form } from 'mobx-react-form';
import { Action } from '../models/BaseFormStoreTypes';

export default class BaseFormStore {
    constructor(actions: Action) {
        this.actions = actions;

        makeObservable(this, {
            isCreateNewMode: observable,
            isFormInitializing: observable,
            isFormInitialized: observable,
            form: observable,
            initializeForm: action,
            clearFormState: action
        })
    }

    isCreateNewMode: boolean = false;
    isFormInitializing: boolean = true;
    isFormInitialized: boolean = false;
    form: Form;
    actions: Action

    initializeForm = async (isCreateNewMode: boolean, itemId: string | null = null) => {
        this.isFormInitializing = true;
        this.isCreateNewMode = isCreateNewMode;

        var itemToEdit: object | null = null;

        if (isCreateNewMode === false) {
            if (itemId == null) {
                return;
            }

            itemToEdit = await this.actions.fnGet(itemId);
        }

        runInAction(() => {
            if (itemToEdit != null) {
                this.form.update({ ...itemToEdit })
            }
            else {
                this.form.clear();
            }

            this.isFormInitializing = false;
            this.isFormInitialized = true;
        });
    }

    clearFormState = () => {
        this.isFormInitialized = false;
        this.form.clear();
    }
}